import persistence from '../persistence';

const cookieStorage = persistence('cookieStorage');

const useUserRole = () => cookieStorage.getRole();

export default useUserRole;
